/**
 * Cómo se lee el estado de una solicitud en los listados.
 *
 * «Observaciones» necesita destacar: es el único estado donde la pelota está
 * del lado del cliente, y el requerimiento pide que lo identifique de un
 * vistazo sin abrir el detalle. Los demás se comportan como siempre.
 *
 * Vive aparte porque los dos sectores tienen tablas propias y esto tiene que
 * leerse igual en ambas.
 */

/** Estado que espera una acción del cliente, no de NPMX. */
const REQUIERE_AL_CLIENTE = "OBSERVACIONES";

/** Etiquetas legibles para los códigos que no se explican solos. */
const ETIQUETAS: Record<string, string> = {
  OBSERVACIONES: "Observaciones",
  REVISION: "Revisión y decisión",
};

export function etiquetaEstado(codigo: string | null | undefined): string {
  if (!codigo) return "—";
  return ETIQUETAS[codigo] ?? codigo;
}

export function estadoTono(
  codigo: string | null | undefined,
  cerrada: boolean,
): "err" | "ok" | "info" | "warn" {
  if (codigo?.startsWith("RECHAZO")) return "err";
  // Antes que "cerrada": una solicitud en observaciones nunca está cerrada,
  // pero el orden deja claro que este caso manda sobre el estado normal.
  if (codigo === REQUIERE_AL_CLIENTE) return "warn";
  if (cerrada) return "ok";
  return "info";
}
